// import Icon from '@ant-design/icons';
import React, { useState, useEffect } from "react";
import { Table, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import liracrypt from "../../../components/Liracrypt/liracrypt";
import SessionError from "../../../components/ApiErrorComp/SessionError";
import ApiErrorComp from "../../../components/ApiErrorComp/ApiErrorComp";
import StablePrime from "../../../components/Tables/StablePrime";
const columns = [
  {
    title: "Station",
    dataIndex: "_id",
    key: "_id",
  },
  {
    title: "Process",
    dataIndex: "Process",
    key: "Process",
  },
  {
    title: "Document #",
    dataIndex: "Document #",
    key: "Link",
    render: (text, record) => (
      <a
        href={record.Link}
        target="_blank"
        rel="noopener noreferrer"
        className="gx-link"
      >
        {text}
      </a>
    ),
  },
];

const SOP = ({ selectedLid }) => {
  const [data, setData] = useState(null);
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const [loginError, setLoginError] = useState(false);

  const fetchDownTimeData = () => {
    liracrypt
      .get("/linedash/tabs/sop", { lid: selectedLid })
      .then(({ data }) => {
        setData(data.data);
      })
      .catch(function (error) {
        // message.error('ERROR: Unable to save!', 4);
        ("Error****:");
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  useEffect(() => {
    if (data === null) {
      fetchDownTimeData();
    }
  }, [data]);
  return data ? (
    <>
      <SessionError visible={loginError} />
      <div style={{ padding: "10px" }}>
        <StablePrime url="/textapi" data={{ dn: "LD_Tab_SOP" }} />
        {/* <Table
          className="gx-table-responsive TableBlack"
          columns={columns}
          dataSource={data}
        /> */}
      </div>
    </>
  ) : (
    <>
      <SessionError visible={loginError} />
      <div className="Loading">
        <Spin indicator={antIcon} />
      </div>
    </>
  );
};

export default SOP;
